const React = require('react');
const PropTypes = React.PropTypes; //TODO: react 15.5 -> require( 'prop-types' );
const compose = require('../ClassComposer');

import Transition from './Transition.jsx';

/**
 * Beware of Math!
 *
 * User: Oleg Kamlowski <oleg.kamlowski@thomann.de>
 * Date: 25.01.2017
 * Time: 10:55
 */
class RangeSlider extends React.Component {
    constructor() {
        super();

        this.state = {
            dragging: false
        };

        this.handles = [];
        this.boundary = null;
        this.offset = 0;
        this.rect = {};
        this.locked = [];
    }

    /**
     * Reinitialize handles
     */
    componentWillReceiveProps() {
        if (!this.state.dragging) {
            this._reinitialize();
        }
    }

    /**
     * Return all distributions between all Sliders and calculate
     * dimensions of itself after mount.
     */
    componentDidMount() {
        let {onMount} = this.props;
        let {handles} = this;

        this._boundary();

        if (onMount) {
            onMount(handles.map((handle, id) => this._calculate(id, handle)))
        }
    }

    /**
     * On Drag Slider.
     *
     * @param id
     * @param event
     * @param click
     * @param touching
     * @returns {{left, top}|*}
     * @private
     */
    _onDrag(id, event, click, touching) {
        let {onDrag, snap} = this.props;
        let {handles} = this;

        let position = this._move(id, event, click, touching);

        if (snap) {
            position = this._snap(id);
        }

        this.setState({
            dragging: true
        });

        let ratios = this._calculate(id, position);

        if (onDrag) {
            onDrag(ratios);
        }

        handles[id].left = position.left;
        handles[id].top = position.top;

        this.handles = handles;

        return {
            position,
            ratio: ratios[id]
        };
    }

    /**
     * On Stop Slider.
     *
     * @param id
     * @returns {{left, top}}
     * @private
     */
    _onStop(id) {
        let {onRelease} = this.props;
        let {handles} = this;

        this.setState({
            dragging: false
        });

        if (onRelease) {
            onRelease(this._calculate(id, handles[id]))
        }

        this.handles = handles;

        return handles[id];
    }

    /**
     * Register a mounted handle and its dimension and position.
     *
     * @param id
     * @param rect
     * @private
     */
    _onUpdate(id, rect) {
        let {handles} = this;

        handles[id] = rect;
        this.handles = handles;

        this.forceUpdate();
    }

    /**
     *
     * @private
     */
    _onResize(id) {
        this._reinitialize();
        this._boundary();

        this.forceUpdate();
    }

    /**
     * Calculation of the dimensions of the whole container.
     *
     * @private
     */
    _boundary() {
        const {parent} = this.refs;
        const {axis} = this.props;
        const {handles} = this;

        let {width, height} = window.getComputedStyle(parent);

        this.rect = {
            width: parseInt(width),
            height: parseInt(height)
        };

        this.offset = handles.reduce((prev, handle) => {
            return prev += handle[Constants.DIMENSION[axis]];
        }, 0);

        this.boundary = handles.reduce((prev, handle) => {
            return prev - handle[Constants.DIMENSION[axis]];
        }, this.rect[Constants.DIMENSION[axis]]);
    }

    /**
     * Calculate the distributions between each handle.
     *
     * todo: compare only the first 2 closest handles
     *
     * @param id
     * @param position
     * @returns {Array}
     * @private
     */
    _calculate(id, position) {
        const {handles, boundary} = this;
        const {axis, relative, precision, range, func} = this.props;

        return handles
            .map((item, i) => {
                let min = 0, max, ratio;

                if (handles[i - 1] != null && relative) {
                    min = handles[i - 1][Constants.POSITION[axis]];
                }

                max = (i == id)
                    ? position[Constants.POSITION[axis]]
                    : handles[i][Constants.POSITION[axis]];

                // between 0 and 100
                ratio = 100 / boundary * (max - min);

                if (range) {
                    let min = Math.min(...range);
                    let max = Math.max(...range);

                    ratio = func(ratio, min, max);
                }

                if (precision != null && precision >= 0) {
                    ratio = parseFloat(ratio).toFixed(precision);
                } else if (precision < 0) {
                    let factor = Math.pow(10, -precision);
                    ratio = Math.round(parseFloat(ratio) / factor) * factor;
                }

                return ratio;
            })
    }

    /**
     * This also restricts the direction, given by the axis prop.
     * Move the handle.
     *
     * @param id
     * @param event
     * @param click
     * @param touching
     * @returns {{left: *, top: *}}
     * @private
     */
    _move(id, event, click, touching) {
        const {axis} = this.props;
        const {handles} = this;

        let left = handles[id].left;
        let top = handles[id].top;

        if (touching) {
            event = event.touches[0];
        }

        if (axis == RangeSlider.Axis.X && event) {
            left = event.clientX - click[Constants.POSITION[axis]];
        }

        if (axis == RangeSlider.Axis.Y && event) {
            top = event.clientY - click[Constants.POSITION[axis]];
        }

        [left, top] = this._clamp(id, left, top);

        handles[id].left = left;
        handles[id].top = top;

        this.handles = handles;

        return {
            left, top
        }
    }

    /**
     * Resets the handles.
     */
    _reinitialize() {
        this.locked = [];
    }

    /**
     * TODO: FIX
     *
     * The calculated position is right, but since the sliders are
     * relative to each other, they do orient themselfs by their previous sibling.
     *
     * And thus, a offset could happen, if the previous siblings are stacked.
     * This is going to be a pain in the butt to fix. :/
     *
     * Btw, it works perfectly with just one handle.
     *
     * @param id
     * @returns {*}
     * @private
     */
    _snap(id) {
        let {handles, rect, offset} = this;
        let {points, axis} = this.props;

        let total = rect[Constants.DIMENSION[axis]];

        offset /= handles.length;
        total -= offset;

        let min = Math.min(...points);
        let max = Math.max(...points);

        handles.forEach((handle, i) => {
            let pointer = handle[Constants.POSITION[axis]];

            let dest = []
                .concat(points)
                .sort((a, b) => {
                    a = total * (a - min) / (max - min);
                    b = total * (b - min) / (max - min);

                    return Math.abs(a - pointer) - Math.abs(b - pointer)
                })
                .shift();

            handles[i][Constants.POSITION[axis]] = total * (dest - min) / (max - min);

            this.handles = handles;
        });

        return this.handles[id];
    }

    /**
     * Clamp left and top position to prevent
     * handle overlapping or going out-of-bounds.
     *
     * @param id
     * @param left
     * @param top
     * @returns {[*,*]}
     * @private
     */
    _clamp(id, left, top) {
        let {handles, rect} = this;
        let {axis, grid} = this.props;

        if (grid) {
            [left, top] = this._grid(grid, left, top);
        }

        let max = {
            [RangeSlider.Axis.X]: rect.width,
            [RangeSlider.Axis.Y]: rect.height
        };

        let min = {
            [RangeSlider.Axis.X]: 0,
            [RangeSlider.Axis.Y]: 0
        };

        if (handles[id + 1] != null) {
            max[axis] = handles[id + 1][Constants.POSITION[axis]];
        } else {
            max[axis] = handles.reduce(
                (p, handle) => p - handle[Constants.DIMENSION[axis]], max[axis]
            );
        }

        if (handles[id - 1] != null) {
            min[axis] = handles[id - 1][Constants.POSITION[axis]];
        }

        return [
            Math.max(Math.min(left, max[RangeSlider.Axis.X]), min[RangeSlider.Axis.X]),
            Math.max(Math.min(top, max[RangeSlider.Axis.Y]), min[RangeSlider.Axis.Y])
        ]
    }

    /**
     * Snap left and top to a griven grid.
     *
     * @param grid
     * @param left
     * @param top
     * @returns {[*,*]}
     * @private
     */
    _grid(grid, left, top) {
        const [a, b] = grid;

        return [
            Math.round(left / a) * a,
            Math.round(top / b) * b
        ];
    }

    /**
     *
     * @private
     */
    _waypoints() {
        let {points, axis, func} = this.props;
        let {handles, rect, offset} = this;

        if (!points || points.length < 2 || handles.length == 0) {
            return [];
        }

        let total = (rect[Constants.DIMENSION[axis]] - 1);

        offset /= handles.length;
        total -= offset;

        let min = Math.min(...points);
        let max = Math.max(...points);

        let waypoints = [];
        let pool = [];

        points
            .filter((point, i, s) => i == s.indexOf(parseInt(point)))
            .forEach((point) => {
                let position = 0;

                // ratio =^= [min, max];
                // let ratio = 100 / (max - min) * (point - min);

                if (func == RangeSlider.Function.LINEAR) {
                    position = total / 100 * (100 / (max - min) * (point - min))
                } else if (func == RangeSlider.Function.LOGARITHMIC) {
                    let minv = Math.log(min);
                    minv = (Number.NEGATIVE_INFINITY == minv)
                        ? 0
                        : minv;
                    let maxv = Math.log(max);

                    position = total * (Math.log(point) - minv) / (maxv - minv);
                    position = (Number.NEGATIVE_INFINITY == position)
                        ? 0
                        : position;
                } else {
                    position = func(point, min, max);
                }

                let lookup = Math.round(position);

                if (pool.indexOf(lookup) < 0) {
                    waypoints.push(
                        <div
                            className="rangeslider-waypoint" key={'waypoint' + point}
                            style={{[Constants.POSITION[axis]]: position + 'px'}}
                        />
                    );
                }

                pool.push(lookup);
            });

        return waypoints;
    }

    /**
     * Initial set the current handle.
     *
     * @param id
     * @param val
     * @returns {number}
     * @private
     */
    _position(id, val) {
        let {boundary} = this;
        let {points, range, func} = this.props;

        let max = boundary;
        let min = 0;

        if (points) {
            max = Math.max(...points);
            min = Math.min(...points);
        }

        if (range) {
            max = Math.max(...range);
            min = Math.min(...range);
        }

        val = Math.min(Math.max(val, min), max);

        this.locked[id] = true;

        if (func == RangeSlider.Function.LOGARITHMIC) {
            let minv = Math.log(min);
            minv = (Number.NEGATIVE_INFINITY == minv)
                ? 0
                : minv;
            let maxv = Math.log(max);
            let scale = (maxv - minv) / 100;

            return boundary / 100 * (Math.log(val) - minv) / scale;
        } else {
            return boundary * (100 / (max - min) * ((val - min) / 100));
        }
    }

    /**
     * Creates the bars.
     *
     * @returns {Array}
     * @private
     */
    _bars() {
        let {axis} = this.props;
        let {handles} = this;
        let bars = [];

        if (handles.length == 1) {
            let handle = handles[0];
            let dim = handle[Constants.POSITION[axis]];

            bars.push(
                <div
                    className="rangeslider-bar" key={0}
                    style={{
                        [Constants.POSITION[axis]]: 0 + 'px',
                        [Constants.DIMENSION[axis]]: dim + 'px'
                    }}
                />
            );
        } else {
            let prev = 0;

            for (let i = 0; i <= handles.length - 2; i++) {
                let left = handles[i];
                let right = handles[i + 1];

                let self = left[Constants.DIMENSION[axis]];
                prev += self * 0.5;

                let pos = left[Constants.POSITION[axis]] + prev - self * 0.5;
                prev += self * 0.5;

                let dim = right[Constants.POSITION[axis]] - pos + prev ;

                bars.push(
                    <div
                        className="rangeslider-bar" key={i}
                        style={{
                            [Constants.POSITION[axis]]: pos + 'px',
                            [Constants.DIMENSION[axis]]: dim + 'px'
                        }}
                    />
                );
            }
        }

        return bars;
    }

    _sliders() {
        let {axis, children} = this.props;
        let {boundary, locked} = this;

        let position = '';
        let i = 0;

        return React.Children.map(children, child => {
            if (i == 0 && (children.length - 1 !== 0)) {
                position = 'first';
            } else if (i == (children.length - 1) && (children.length - 1 !== 0)) {
                position = 'last';
            } else {
                position = '';
            }

            let value = child.props.value || child.props.initial;
            if (value && boundary && locked[i] == null) {
                value = this._position(i, value);
            } else {
                value = null;
            }

            return React.cloneElement(child, {
                id: i++,
                axis,
                value,
                position,
                onUpdate: (id, dimension) => this._onUpdate(id, dimension),
                onDrag: (id, event, click, touching) => this._onDrag(id, event, click, touching),
                onStop: (id) => this._onStop(id),
                onResize: (id) => this._onResize(id)
            })
        });
    }

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        const {handles, offset} = this;
        let {axis, className, show} = this.props;

        let bars = show.indexOf(RangeSlider.Show.BARS) > -1 && this._bars();
        let waypoints = show.indexOf(RangeSlider.Show.WAYPOINTS) > -1 && this._waypoints();

        let sliders = this._sliders();

        className = compose(className, 'rangeslider', {
            horizontal: (axis == RangeSlider.Axis.X),
            vertical: (axis == RangeSlider.Axis.Y)
        });

        return (
            <div
                className={className}
                ref="parent"
            >
                <div
                    className="rangeslider-rail"
                    style={{
                        width: 'calc(100% - ' + (offset / handles.length) + 'px)',
                        left: (offset / handles.length) / 2 + 'px'
                    }}
                >
                    {(waypoints) &&
                        <Transition
                            children={waypoints}
                            monitor={waypoints.length}
                        />
                    }
                    {bars}
                </div>
                {sliders}
            </div>
        )
    }
}


/**
 * User: Oleg Kamlowski <oleg.kamlowski@thomann.de>
 * Date: 25.01.2017
 * Time: 11:26
 */
class Slider extends React.Component {
    constructor() {
        super();

        this._onDragEndListener = this._onDragEnd.bind(this);
        this._onDragListener = this._onDrag.bind(this);
        this._onDragStartListener  = this._onDragStart.bind(this);
        this._onResizeListener  = this._onResize.bind(this);

        this.handleEvents = {};

        this.state = {
            dragging: false,
            touching: false,
            left: '0px',
            top: '0px',
            rect: {},
            click: {}
        };
    }

    /**
     *  Registers a MouseUp Event,
     *  calculates the position and dimension of ifself and
     *  passes this to the parrent.
     */
    componentDidMount() {
        // these are here on purpose, workaround for passive events
        this._addEvent(this.refs.element, Event.MOUSEDOWN, this._onDragStartListener, false, true);
        this._addEvent(this.refs.element, Event.TOUCHSTART, this._onDragStartListener, false, true);
        this._addEvent(window, Event.RESIZE, this._onResizeListener, false, true);

        const {id, onUpdate} = this.props;
        const rect = this._getRect();

        onUpdate(id, rect);
    }

    /**
     * Positionize handle
     *
     * @param props
     */
    componentWillReceiveProps(props) {
        if (props.value != null) {
            this._setPosition(props.value);
        }
    }

    /**
     * Set the handle to a initial position.
     */
    _setPosition(pos) {
        let {axis, onUpdate, id} = this.props;

        this.setState({
            [Constants.POSITION[axis]]: pos + 'px'
        });

        let rect = this._getRect();
        rect[Constants.POSITION[axis]] = pos;

        onUpdate(id, rect);
    }

    /**
     * Removes all Events.
     */
    componentWillUnmount() {
        this._clearEvents(true);
    }

    /**
     * Registers an Event to the eventpool and document.
     *
     * @param node
     * @param event
     * @param handler
     * @param options
     * @param permanent
     * @private
     */
    _addEvent(node, event, handler, options, permanent = false) {

        this.handleEvents[event] = {
            permanent,
            remove() {
                node.removeEventListener(event, handler);
            }
        };

        node.addEventListener(event, handler, options || false);
    }

    /**
     * Removes all Events registered in the eventpool.
     *
     * @param all
     * @private
     */
    _clearEvents(all = false) {
        Object.keys(this.handleEvents).forEach((key) => {
            const event = this.handleEvents[key];

            if (!event.permanent || all) {
                event.remove();
                delete this.handleEvents[key];
            }
        });
    }

    /**
     * Registers a MouseMove Event
     * calculates the position and dimension of the handle
     * and sets the state.
     *
     * @param e
     * @private
     */
    _onDragStart(e) {
        const touching = e.touches;

        if (e.button != MouseLeft && !touching) {
            return;
        }

        e.preventDefault();

        this._addEvent(document, Event.MOUSEUP, this._onDragEndListener);
        this._addEvent(document, Event.TOUCHEND, this._onDragEndListener);
        this._addEvent(document, Event.MOUSEMOVE, this._onDragListener);
        this._addEvent(document, Event.TOUCHMOVE, this._onDragListener);

        const rect = this._getRect();

        if (touching) {
            e = e.touches[0];
        }

        this.setState({
            dragging: true,
            touching,
            click: {
                left: e.clientX - rect.left,
                top: e.clientY - rect.top
            },
            rect
        });
    }

    /**
     * Uppon mouse moving, it passes the id, event, click position and
     * position, dimension of itself to the parrent, where the
     * actuall postion calculation takes place.
     *
     * @param e
     * @private
     */
    _onDrag(e) {
        const {onDrag, onChange, id} = this.props;
        const {dragging, click, touching} = this.state;

        if (!dragging) {
            return;
        }

        let {position: {left, top}, ratio} = onDrag(id, e, click, touching);

        if (onChange) {
            onChange(ratio);
        }

        this.setState({
            left: left + 'px',
            top: top + 'px',
        })
    }

    /**
     * Removes the MouseMove event and sets dragging to false.
     *
     * @private
     */
    _onDragEnd() {
        const {onStop, id} = this.props;

        let {left, top} = onStop(id);

        this.setState({
            left: left + 'px',
            top: top + 'px',
        });

        this._clearEvents();

        this.setState({
            dragging: false
        });
    }

    /**
     * Update dimensions and boundaries.
     *
     * @private
     */
    _onResize() {
        const {onResize, onChange, initial, id} = this.props;

        if (onChange && initial) {
            onChange(initial);
        }

        onResize(id);
    }

    /**
     * Calculates the position and dimension of the handle in the dom.
     *
     * @returns {{top: Number, left: Number, width: Number, height: Number}}
     * @private
     */
    _getRect() {
        const {element} = this.refs;
        const {width, height, top, left} = window.getComputedStyle(element);

        return {
            top: parseInt(top),
            left: parseInt(left),
            width: parseInt(width),
            height: parseInt(height)
        };
    }

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        let {children, className, position} = this.props;
        let {left, top} = this.state;

        className = compose('rangeslider-handle', className, {
            [position]: position
        });

        return (
            <div
                className={className}
                ref="element"
                style={{left, top}}
                children={children}
            />
        );
    }
}

RangeSlider.Axis = {
    X: 'x',
    Y: 'y'
};

RangeSlider.Show = {
    BARS: 'bars',
    WAYPOINTS: 'waypoints'
};

RangeSlider.Function = {
    LINEAR: (v, x, y) => ((y - x) * v / 100) + x,
    LOGARITHMIC: (v, x, y, m = 0, n = 100) => {
        x = Math.log(x);
        x = (Number.NEGATIVE_INFINITY == x)
            ? 0
            : x;
        return Math.exp(x + ((Math.log(y) - x) / (n - m)) * (v - m))
    }
};

RangeSlider.defaultProps = {
    axis: RangeSlider.Axis.X,
    func: RangeSlider.Function.LINEAR,
    show: []
};

RangeSlider.propTypes = {
    axis: React.PropTypes.any,
    grid: React.PropTypes.any,
    snap: React.PropTypes.bool,
    show: React.PropTypes.oneOfType([
        React.PropTypes.array,
        React.PropTypes.string
    ]),
    onDrag: React.PropTypes.func,
    onRelease: React.PropTypes.func,
    onUpdate: React.PropTypes.func,
    range: React.PropTypes.array,
    points: React.PropTypes.array,
    relative: React.PropTypes.bool,
    precision: React.PropTypes.number,
    func: React.PropTypes.func
};

Slider.propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number,
    ]),
    initial: React.PropTypes.oneOfType([
        React.PropTypes.string,
        React.PropTypes.number
    ])
};

const Constants = {
    POSITION: {
        [RangeSlider.Axis.X]: 'left',
        [RangeSlider.Axis.Y]: 'top',
    },
    DIMENSION: {
        [RangeSlider.Axis.X]: 'width',
        [RangeSlider.Axis.Y]: 'height',
    }
};

const MouseLeft = 0;

const Event = {
    MOUSEDOWN: 'mousedown',
    MOUSEUP: 'mouseup',
    MOUSEMOVE: 'mousemove',
    TOUCHSTART: 'touchstart',
    TOUCHEND: 'touchend',
    TOUCHMOVE: 'touchmove',
    RESIZE: 'resize'
};

export default RangeSlider;
export {Slider};



// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/RangeSliderv2.jsx